import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import colors from 'theme/colors'

export default function Progress({ value = 0, bgColor, color }) {
    const [progressValue, setProgressValue] = useState(0);

    useEffect(() => {
        setProgressValue(value);
    }, [value]);

    return (
        <StyledProgressContainer bgColor={bgColor}>
            <StyledProgressContent progress={progressValue} color={color} />
        </StyledProgressContainer>
    )
}

const StyledProgressContainer = styled.div`
    background: transparent;
    width: 100%;
    height: ${({ bgColor }) => bgColor ? '12px' : '15px'};
    border-radius: 30px;
    border: 1px solid ${colors.neutralDark};
    padding: ${({ bgColor }) => bgColor ? 0 : '1px'};
    /* box-shadow: 0px 0px 6px ${colors.occasionalPurple}; */
    box-shadow: 0px 0px 6px ${({ bgColor }) => bgColor ? 'transparent' : colors.occasionalPurple};
    background-color: ${({ bgColor }) => bgColor || 'transparent'};
`;

const StyledProgressContent = styled.div`
    /* background: ${colors.occasionalPurple}; */
    background-color: ${({ color }) => color || colors.occasionalPurple};   
    height: 100%;
    border-radius: 30px;
    width: ${({ progress }) => progress}%; 
    transition: width .7s ease-in-out;
`;
